export const themeDark = {
    name: 'dark',
    className: 'dockview-theme-dark',
};
export const themeLight = {
    name: 'light',
    className: 'dockview-theme-light',
};
export const themeVisualStudio = {
    name: 'visualStudio',
    className: 'dockview-theme-vs',
};
export const themeAbyss = {
    name: 'abyss',
    className: 'dockview-theme-abyss',
};
export const themeDracula = {
    name: 'dracula',
    className: 'dockview-theme-dracula',
};
export const themeReplit = {
    name: 'replit',
    className: 'dockview-theme-replit',
    gap: 10,
};
export const themeAbyssSpaced = {
    name: 'abyssSpaced',
    className: 'dockview-theme-abyss-spaced',
    gap: 10,
    dndOverlayMounting: 'absolute',
    dndPanelOverlay: 'group',
};
export const themeLightSpaced = {
    name: 'lightSpaced',
    className: 'dockview-theme-light-spaced',
    gap: 10,
    dndOverlayMounting: 'absolute',
    dndPanelOverlay: 'group',
};
